import { createZodDto } from 'nestjs-zod';
import { z } from 'zod';

export const createFormulaSetDto = z.object({
  id: z.string(),
  note: z.string().optional(),
});

export class CreateFormulaSetDto extends createZodDto(createFormulaSetDto) {}
